import React from 'react';
import './About.css';

const hobbies = [
  'Keyboards ⌨️',
  'Skiing ⛷️',
  'Mountain Biking 🚴‍♂️',
  'Simulator Racing 🏎️',
  'Planes 🛩️',
  'Watches ⏱️',
  'Golf 🏌️',
  'Tennis 🎾',
  'Road Biking 🚴',
  'Chess ♟️',
  'Premier Leauge [Arsenal ⚽️]'
];

const books = [
  { cover: '/images/bookcovers/atomichabits.jpg', title: 'Atomic Habits', author: 'James Clear' },
  { cover: '/images/bookcovers/thinkingfastandslow.jpg', title: 'Thinking, Fast and Slow', author: 'Daniel Kahneman' },
  { cover: '/images/bookcovers/whitenoise.jpg', title: 'White Noise', author: 'Don DeLillo' },
  { cover: '/images/bookcovers/TheUnbearableLightnessofbeing.jpg', title: 'The Unbearable Lightness of Being', author: 'Milan Kundera' },
  { cover: '/images/bookcovers/The%20vanishing%20half.jpg', title: 'The Vanishing Half', author: 'Brit Bennett' },
  { cover: '/images/bookcovers/goodtogreat.jpg', title: 'Good to Great', author: 'Jim Collins' },
];

const HobbyGroup = () => (
  <div className="hobby-group">
    {hobbies.map((hobby) => (
      <div className="hobby-item" key={hobby}>{hobby}</div>
    ))}
  </div>
);

const BookGroup = () => (
  <div className="book-group">
    {books.map((book) => (
      <div className="book" key={book.title}>
        <img
          src={book.cover}
          alt={`${book.title} by ${book.author}`}
          className="book-cover"
        />
        <div className="book-info">
          <h3>{book.title}</h3>
          <p>{book.author}</p>
        </div>
      </div>
    ))}
  </div>
);

const About = () => {
  return (
    <div className="about-container">
      <section className="about-section">
        <div className="section-head">
          <span className="section-index">01</span>
          <h2 className="section-title">Hobbies &amp; Interests</h2>
        </div>
        <div className="hobbies-banner">
          <div className="hobbies-track">
            <HobbyGroup />
            <HobbyGroup />
          </div>
        </div>
      </section>

      <section className="about-section">
        <div className="section-head">
          <span className="section-index">02</span>
          <h2 className="section-title">Bookshelf</h2>
        </div>
        <div className="books-banner">
          <div className="books-track">
            <BookGroup />
            <BookGroup />
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
